module.exports = __webpack_public_path__ + "img/rlmt_therealms4vr.b169008.png";